<template>
    <fieldset>
        <p class="instruct-sm">Need help understanding the fields? <a onclick="$('#PayPal_info').modal('show');">Click here</a> for more info.</p>

        <div class="split-fields">
            <txt label="Business Name" v-model="model.config.brandName"></txt>
            <txt label="Api Username" v-model="model.config.username"></txt>
        </div>

        <div class="split-fields">
            <txt label="Api Password" v-model="model.config.password"></txt>
            <txt label="Api Signature" v-model="model.config.signature"></txt>
        </div>
        <div class="split-fields">
            <list label="Solution Type" v-model="model.config.solutionType" :list="['Sole', 'Mark']" :selected="'Sole'"></list>
            <list label="Landing Page" v-model="model.config.landingPage" :list="['Billing', 'Login']" :selected="'Login'"></list>
        </div>
        <div class="split-fields">
            <txt label="Header Image Url" v-model="model.config.headerImageUrl"></txt>
            <txt label="Logo Image Url" v-model="model.config.logoImageUrl"></txt>
        </div>
        <div class="split-fields">
            <txt label="Border Color" v-model="model.config.borderColor"></txt>
            <input type="checkbox" value="true" v-model="model.config.testMode" /> <label>Test Mode</label>
        </div>

        <div class="form-group">
            <label class="control-label">Sort Order</label>
            <input class="form-control" type="text" value="true" v-model="model.sort" />
        </div>

        <input type="checkbox" value="true" v-model="model.status" /> <label>Enabled</label>

        <div class="buttons">
            <button class="btn btn-success btn-sml" @click.prevent="store"><i class="icon icon-save"></i> Save</button>
        </div>
  </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        data: function() {
            return {
                model: {
                    type: 'PayPal_Express',
                    gateway_type: 1,
                    public_id: 0,
                    sort: 0,
                    status: true,
                    config: {
                        username: '',
                        solutionType: '',
                        landingPage: '',
                        password: '',
                        signature: '',
                        testMode: false,
                        brandName: '',
                        headerImageUrl: '',
                        logoImageUrl: '',
                        borderColor: '',
                    }
                }
            }
        },
        created() {
            this.$eventHub.$on('gatewaySubmit', this.store);
            this.$eventHub.$on('setPaymentGateways', this.setData);
        },
        methods: {
            store() {
                this.$store('/api/payment-gateways/store', this);
            },
            setData(data) {
                if (data.gateway_id !== this.model.type) return;
                this.model = this.$setData(data, this.model);
                this.model.type = data.gateway_id;
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('productSubmit', this.store);
            this.$eventHub.$off('setPaymentGateways', this.setData);
        },
        components: {
            'txt': require('../../../components/form/text.vue').default
        }
    }
</script>